import React from 'react';

const CopyIconFill = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10 10C10 8.1144 10 7.1716 9.41421 6.58579C8.8284 6 7.8856 6 6 6H5.33333C3.44773 6 2.50493 6 1.91913 6.58579C1.33333 7.1716 1.33333 8.1144 1.33333 10V10.6667C1.33333 12.5523 1.33333 13.4951 1.91913 14.0809C2.50493 14.6667 3.44773 14.6667 5.33333 14.6667H6C7.8856 14.6667 8.8284 14.6667 9.41421 14.0809C10 13.4951 10 12.5523 10 10.6667V10Z",
      fill: "#9BA0A1"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10 10C10 8.1144 10 7.1716 9.41421 6.58579C8.8284 6 7.8856 6 6 6H5.33333C3.44773 6 2.50493 6 1.91913 6.58579C1.33333 7.1716 1.33333 8.1144 1.33333 10V10.6667C1.33333 12.5523 1.33333 13.4951 1.91913 14.0809C2.50493 14.6667 3.44773 14.6667 5.33333 14.6667H6C7.8856 14.6667 8.8284 14.6667 9.41421 14.0809C10 13.4951 10 12.5523 10 10.6667V10Z",
      stroke: "#9BA0A1",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.66608 5.99992C4.66768 4.02853 4.69748 3.00739 5.27135 2.30821C5.38215 2.17318 5.50595 2.04937 5.64095 1.93856C6.37855 1.33325 7.47435 1.33325 9.66602 1.33325C11.8577 1.33325 12.9535 1.33325 13.6911 1.93856C13.8261 2.04937 13.9499 2.17318 14.0607 2.30821C14.666 3.04577 14.666 4.1416 14.666 6.33325C14.666 8.52492 14.666 9.62072 14.0607 10.3583C13.9499 10.4933 13.8261 10.6171 13.6911 10.7279C12.9919 11.3018 11.9707 11.3316 9.99935 11.3332",
      stroke: "#9BA0A1",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
CopyIconFill.displayName = "Icons.CopyIconFill";

export { CopyIconFill };
//# sourceMappingURL=CopyIconFill.js.map
